import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SubPage } from "@/components/profile/SettingsKit";
import { Card } from "@/components/ui";
import { buildHead, SITE } from "@/lib/seo";

export const Route = createFileRoute("/_app/settings_/privacy")({
  head: () =>
    buildHead({
      path: "/settings/privacy",
      title: "Privacy policy",
      description: `How ${SITE.name} collects, uses and protects your personal data.`,
    }),
  component: PrivacyPage,
});

// NOTE: placeholder policy copy — replace with your reviewed legal text.
// Section bodies live in the account catalog as privacy.sections.<id>.{h,p}.
const SECTION_IDS = ["collect", "use", "sharing", "security", "choices", "contact"] as const;

function PrivacyPage() {
  const { t } = useTranslation("account");
  return (
    <SubPage title={t("privacy.title")} subtitle={t("privacy.subtitle")}>
      <Card className="space-y-5 p-5">
        {SECTION_IDS.map((id) => (
          <section key={id}>
            <h2 className="mb-1 text-sm font-semibold text-fg">{t(`privacy.sections.${id}.h`)}</h2>
            <p className="text-sm leading-relaxed text-fg-muted">{t(`privacy.sections.${id}.p`)}</p>
          </section>
        ))}
      </Card>
    </SubPage>
  );
}
